import styled, { css } from 'styled-components';
import { Box } from '@mui/material';
import { colors } from '@/globalStyles';
import store from '@/store';
import { SMARTPHONE } from '@/constants';

export const ModalWrapperStyled = styled.div`
  width: 620px;
  outline: none;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: ${colors.white};
  border-radius: 10px;
  box-shadow: 2px 4px 16px 0 rgba(0, 0, 0, 0.25);
  padding: 30px;

  ${props => {
    const { core: { targetDevice } } = store.getState();

    switch (targetDevice) {
      case SMARTPHONE: {
        return css``;
      }
      default: {
        return null;
      }
    }
  }}
`;

export const ModalHeaderStyled = styled.div`
  font-size: 24px;
  font-family: IBMPlexSans;
  font-weight: 700;
  margin-bottom: 30px;
`;

export const ModalBodyStyled = styled.div``;

export const RowStyled = styled(Box)`
  display: grid;
  grid-template-columns: 36px 1fr;
  align-items: center;
  gap: 15px;
`;

export const OptionTitleStyled = styled.div`
  font-size: 18px;
  font-family: IBMPlexSans;
  font-weight: 600;
`;

export const DescriptionStyled = styled.div`
  font-size: 18px;
  font-family: SourceSansPro;
  font-weight: 400;
`;

export const ModalFooterStyled = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 60px;
`;